import { useState } from "react";

const tarifs = [
  {
    icon: "ri-stethoscope-line",
    title: "Diagnostic & déplacement",
    price: "Gratuit",
    description: "Visite à domicile dans le Bas-Rhin pour identifier le problème. Devis gratuit, sans engagement.",
    highlight: true,
  },
  {
    icon: "ri-settings-3-line",
    title: "Réglage oscillo-battant",
    price: "Sur devis",
    description: "Réglage des gonds, centrage de la vantaux, remise en route du mécanisme.",
    highlight: false,
  },
  {
    icon: "ri-key-line",
    title: "Crémone",
    price: "Sur devis",
    description: "Remplacement de la crémone complète avec toutes les pièces comprises.",
    highlight: false,
  },
  {
    icon: "ri-hand-coin-line",
    title: "Poignée",
    price: "Sur devis",
    description: "Changement de la poignée ou réparation du carré de transmission. Pièce adaptée.",
    highlight: false,
  },
  {
    icon: "ri-hammer-line",
    title: "Gond / paumelle",
    price: "Sur devis",
    description: "Réglage, remplacement ou changement de hauteur des gonds. Pièce comprise.",
    highlight: false,
  },
];

export default function TarifCards() {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section className="bg-white py-10 md:py-14">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="font-serif italic text-[#1E3A47] text-sm md:text-base mb-2">
            Nos tarifs
          </p>
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-[#1E3A47] mb-4">
            Tarifs de réparation de fenêtre
          </h2>
          <p className="text-[#243038] text-base md:text-lg max-w-2xl mx-auto">
            Tous nos tarifs sont transparents : le diagnostic est gratuit, et chaque devis détaille les pièces et la main-d'œuvre avant intervention.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {tarifs.map((t, i) => (
            <div
              key={t.title}
              className={`relative rounded-2xl border p-5 md:p-6 transition-all duration-300 cursor-default ${
                t.highlight
                  ? "border-[#FF6B4A]/30 bg-[#FF6B4A]/5"
                  : "border-[#D7E0E4] bg-white hover:border-[#FF6B4A]/40"
              }`}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{
                transform: hovered === i ? "translateY(-4px)" : "translateY(0)",
              }}
            >
              {t.highlight && (
                <span className="absolute top-4 right-4 inline-flex items-center gap-1 bg-[#FF6B4A] text-white text-xs font-semibold px-3 py-1 rounded-full">
                  <i className="ri-gift-line" />
                  Offert
                </span>
              )}
              <div className="w-12 h-12 rounded-xl bg-[#EEF2F4] flex items-center justify-center mb-4">
                <i className={`${t.icon} text-[#1E3A47] text-xl`} />
              </div>
              <h3 className="font-serif text-lg md:text-xl font-bold text-[#1E3A47] mb-2">
                {t.title}
              </h3>
              <p className="font-serif text-2xl md:text-3xl font-bold text-[#FF6B4A] mb-3">
                {t.price}
              </p>
              <p className="text-[#243038] text-sm leading-relaxed">
                {t.description}
              </p>
            </div>
          ))}
        </div>

        <p className="text-center text-[#243038]/70 text-sm mt-8 md:mt-10">
          Les tarifs sont établis après diagnostic. Chaque fenêtre est unique : marque, âge, matériau et mécanisme influent sur le coût.
        </p>
      </div>
    </section>
  );
}